import { shareColumnsExtend, shareFormColumnsExtend } from './share';

const entityColumns = {
  id: {
    model_name: 'Project',
    column_type: 'id',
    label_key_path: 'project.id',
  },
  created_at: {
    model_name: 'Project',
    column_type: 'datetime',
    label_key_path: 'project.createdAt',
  },
  updated_at: {
    model_name: 'Project',
    column_type: 'datetime',
    label_key_path: 'project.updatedAt',
  },
  name: {
    model_name: 'Project',
    column_type: 'string',
    label_key_path: 'project.name',
  },
  users: {
    model_name: 'Project',
    column_type: 'has_many',
    label_key_path: 'project.users',
    extra: {
      association_name: 'users',
      model_name: 'User',
      foreign_key: 'user_id',
      display_column: 'screen_name',
    },
  },
  user_ids: {
    model_name: 'Project',
    column_type: 'has_many',
    label_key_path: 'project.users',
    extra: {
      association_name: 'users',
      model_name: 'User',
      foreign_key: 'user_id',
      display_column: 'screen_name',
    },
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(entityColumns, columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(entityColumns, columns, { formColumnsConfig, type, data })
}
